// The UI a loaded trace is looked at through: the dashboard (slice map + timeline),
// whose chip page is opened from it. `create(ctx)` returns {mount(root), unmount(),
// applyHash(h), toHash()}.

import { App as Dashboard } from "./timeline/app.js";

export const UIS = [
  { id: "timeline", title: "Dashboard", create: (ctx) => new Dashboard(ctx) },
];
